import { queryKey } from 'Shared/const/queryKey';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import type { DailyCheckInRound } from '../model/dailyCheckIn/types';
import type { DailyCheckInQueryKey } from './queries';

export const useGetDailyCheckInRound = (
  params?: QueryParam<
    DailyCheckInRound,
    unknown,
    DailyCheckInRound,
    DailyCheckInQueryKey['currentRound']['queryKey']
  >,
) => {
  const queryResult = useSDQuery<
    DailyCheckInRound,
    unknown,
    DailyCheckInRound,
    DailyCheckInQueryKey['currentRound']['queryKey']
  >({
    ...params?.options,
    // 전역 기본값(`shared/network/queryClient.ts`)은 false 다. CTA 잠금이 회차의 `currentSlot` 채움에 묶여
    // 있어서, 정오·자정을 넘겨 돌아온 사용자가 낡은 잠금에 갇히지 않으려면 포커스 복귀 때 다시 읽어야 한다.
    refetchOnWindowFocus: true,
    ...queryKey.dailyCheckIn.currentRound,
  });

  return queryResult;
};
